import { Dropdown, Avatar, Menu } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { userImplement } from '@/config/hooks/user';
import { ENV } from '@/infrastructure/env-config';
import { useAuthContext } from '@/presentation/hooks';
import { TopMenuButton } from '@/presentation/layouts/header/button';
import { stores } from '@/presentation/store';
import style from './index.module.scss';

export const TDSHeader = () => {
  const history = useHistory();
  const { authInfo } = useAuthContext();
  const { isSuperUser } = stores.ProductStore;
  const handleSelect = (key: string) => {
    if (key === 'myAppList') {
      history.push('/workbench/apps');
    }
    if (key === 'profile') {
      history.push('/user/profile');
    }
    if (key === 'coupons') {
      history.push('/user/coupons');
    }
    if (key === 'approval') {
      history.push('/product-approval');
    }
    if (key === 'resourceManage') {
      history.push('/resource-manage');
    }
    if (key === 'expense') {
      history.push('/expense');
    }
    if (key === 'logout') {
      userImplement.logout();
    }
  };

  const renderMenu = () => (
    <Menu onClick={({ key }) => handleSelect(key)}>
      <Menu.Item key="myAppList" className={style.headerMenu}>
        我的产品
      </Menu.Item>
      <Menu.Item key="profile" className={style.headerMenu}>
        个人信息
      </Menu.Item>
      {(!ENV.isGlobal) && <Menu.Item key="expense" className={style.headerMenu}>
        订单管理
      </Menu.Item>}
      {(!ENV.isGlobal) && <Menu.Item key="resourceManage" className={style.headerMenu}>
        资源包
      </Menu.Item>}
      {isSuperUser ? <Menu.Item key="approval"  className={style.headerMenu}>
        产品审批
      </Menu.Item> : null}
      {/* <Menu.Item key="coupons">*/}
      {/*  代金券*/}
      {/* </Menu.Item>*/}
      <Menu.Item key="logout" className={style.headerMenu}>
        退出登录
      </Menu.Item>
    </Menu>
  );

  return (
    <div className={classNames('absolute top-[16px] right-[16px] z-[10000]', style.container)}>
       <div>
            {!authInfo?.isLoggedIn
              ? <TopMenuButton  onClick={() => userImplement.logout()}>
                <span style={{ cursor: 'pointer' }}>登录</span>
              </TopMenuButton> : null
            }
            {authInfo?.isLoggedIn ? <Dropdown overlay={renderMenu} arrow placement={'bottomRight'}>
              <Avatar size={28} src={userImplement.getAvatar()} />
            </Dropdown> : null}
       </div>
    </div>
  );
};
